import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { getCustomButtonStyles, getCustomGlobalStyles } from '../../components/payment-checkout/payment-methods/payment-methods.utils'

export const PaymentRouterContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`

export const dynamicStyle = (displayValue: string) => css`
  .yuno-status .yuno-status__button {
    display: ${displayValue};
  }
`

export const getButtonStyles = (styles: string | null) => {
  return css`
    ${getCustomButtonStyles(styles)}
  `
}

export const getGlobalCustomStyles = (styles: string | null) => {
  return css`
    ${getCustomGlobalStyles(styles)}
  `
}
